import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import JSONPretty from "react-json-pretty";
import { CopyIconButton } from "./AgentDebugTool";

interface MessageEventProps {
  eventString: string;
  index: number;
  combinedIndex: number;
}

export default ({ eventString, index, combinedIndex }: MessageEventProps) => {
  let parsedEvent;
  let parseError = false;
  try {
    parsedEvent = JSON.parse(eventString);
  } catch {
    parsedEvent = eventString;
    parseError = true;
  }

  let content = "";
  let name = ` ${parsedEvent.type}`;
  if (parsedEvent.type === "function_call") {
    name += " • " + parsedEvent.content.name;
  } else if (parsedEvent.type === "function_response") {
    name += " • " + parsedEvent.content.name;
    content = parsedEvent.content.output.llm_content;
  } else if (parsedEvent.type === "chat") {
    name += " • " + parsedEvent.role;
    content = parsedEvent.content.content;
  }

  return (
    <Accordion
      key={`message-${combinedIndex}`}
      sx={{
        marginBottom: "8px !important",
        marginTop: "0px !important",
        ".MuiPaper-root, .MuiPaper-root.Mui-expanded": {
          marginBottom: "8px !important",
          marginTop: "0px !important",
        },
        "&.Mui-expanded": {
          marginBottom: "8px",
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            mr: 1,
          }}
        >
          <Typography>
            <b style={{ marginRight: "8px" }}>
              Message {index + 1} {parseError && " (Parse Error)"}
            </b>
            {name}
          </Typography>
          <CopyIconButton
            text={
              parseError ? eventString : JSON.stringify(parsedEvent, null, 2)
            }
            tooltip="Copy message"
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ overflow: "auto" }}>
          {parseError ? (
            <Typography component="pre" sx={{ whiteSpace: "pre-wrap" }}>
              {eventString}
            </Typography>
          ) : (
            <>
              <JSONPretty
                id={`json-pretty-${combinedIndex}`}
                data={parsedEvent}
                theme={{
                  main: "line-height:1.3;color:#333333;background:#ffffff;overflow:auto;",
                  error:
                    "line-height:1.3;color:#d32f2f;background:#ffffff;overflow:auto;",
                  key: "color:#1976d2;",
                  string: "color:#388e3c;",
                  value: "color:#7b1fa2;",
                  boolean: "color:#f57c00;",
                }}
              />
              {content && (
                <>
                  <Typography variant="bodySmallHeavy">Content</Typography>
                  <Typography
                    variant="bodySmall"
                    color="text.secondary"
                    sx={{ whiteSpace: "pre-wrap" }}
                  >
                    {content}
                  </Typography>
                </>
              )}
            </>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
